module.exports = "https://static.wmbcdn.com/uniweb/images/0eab0330c6e451e8f610e01125c7a663.svg";